import React, { Fragment, } from 'react';
import { Button, } from 'reactstrap';
import { sortBy, last, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { useCounter, useToggle, } from 'react-use';
import classnames from 'classnames';
import { format as formatDate, differenceInSeconds, addMonths, isWithinInterval, eachDayOfInterval, startOfDay, startOfMonth, endOfDay, endOfMonth, addDays, } from 'date-fns';
import qs from 'qs';

import firebase from '../../firebase';
import { statuses, packageTypes, fields, } from '../../shared/models/pickingItem';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentsSubscription from '../hooks/useDocumentsSubscription';
import DateSelector from '../DateSelector';
import ModelFormModal from '../modals/ModelFormModal';
import AdminPage from '../hocs/AdminPage';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import BatchImportButton from '../BatchImportButton';

const db = firebase.firestore();
const usersRef = db.collection('users');
const pickingItemsRef = db.collection('pickingItems');

export default AdminPage(function AdminPickingItems (props) {
  const { history, location } = props;
  const queryParams = qs.parse(decodeURI(location.search.slice(1)));
  const {
    startOn: startOnString = formatDate(addMonths(new Date(), -1), 'yyyy-MM-dd'),
    endOn: endOnString = formatDate(new Date(), 'yyyy-MM-dd'),
  } = queryParams;
  const startOn = startOfDay(new Date(startOnString));
  const endOn = endOfDay(new Date(endOnString));
  const users = useCollectionSubscription(usersRef.where('isStaff', '==', true));
  const usersById = keyBy(users, 'id');
  const pickingItems = useCollectionSubscription(pickingItemsRef.where('createdAt', '>=', startOn).where('createdAt', '<=', endOn), [startOnString, endOnString]);
  const sortedPickingItems = sortBy(pickingItems, _ => _.index);
  const processRows = async (rows) => {
    return await Promise.all(rows.filter(_ => _.id).map(async (row) => {
      return {
        ...row,
        doc: await pickingItemsRef.doc(row.id).get(),
      };
    }));
  };
  const processRow = (batch, row, i) => {
    const { id, productName, doc, } = row;
    const ref = pickingItemsRef.doc(id);
    batch.set(ref, {
      ...pick(row, ['id', 'productName', 'packageType', 'free1', 'free2']),
      ...(
        !doc.exists && {
          createdAt: new Date(),
          status: 'initial',
          index: (get(last(sortedPickingItems), 'index', 0) + 1 + i),
        }
      ),
    }, { merge: true });
  };

  return (
    <div className="admin-pickingItems container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>ピッキングアイテム管理</h4>
        </div>
        <div className="d-flex justify-content-between mb-3 align-items-end">
          <div className="d-flex align-items-end flex-wrap">
            <DateSelector className="ml-2" paramName="startOn" label="開始日" history={history} location={location} defaultValue={addMonths(new Date(), -1)} />
            <DateSelector className="ml-2" paramName="endOn" label="終了日" history={history} location={location} defaultValue={new Date()} invalid={startOn > endOn} />
          </div>
          <BatchImportButton processRows={processRows} processRow={processRow} />
        </div>
        <div className="mt-4 overflow-scroll position-relative" style={{ zIndex: 0 }}>
          {
            sortedPickingItems.length > 0 ? (
              <table className="table sticky-table table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 150 }}>ID</th>
                    <th style={{ minWidth: 150 }}>インポート日</th>
                    <th style={{ minWidth: 150 }}>商品名</th>
                    <th style={{ minWidth: 100 }}>梱包種別</th>
                    <th style={{ minWidth: 100 }}>オプション1</th>
                    <th style={{ minWidth: 100 }}>オプション2</th>
                    <th style={{ minWidth: 100 }}>状態</th>
                    <th style={{ minWidth: 150 }}>作業者</th>
                    <th style={{ minWidth: 150 }}>保留メモ</th>
                    <th style={{ minWidth: 150 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    sortedPickingItems.map((pickingItem) => {
                      const { id, ref, productName, packageType, free1, free2, status = 'initial', pickingBy, pendingNote, createdAt, } = pickingItem;
                      const pickingUser = usersById[pickingBy];
                      const { color } = statuses[status];

                      return (
                        <tr key={id} className={`table-${color}`}>
                          <td>{id}</td>
                          <td>{formatDate(createdAt.toDate(), 'yyyy/MM/dd')}</td>
                          <td>{productName}</td>
                          <td>{get(packageTypes, [packageType, 'label'], '')}</td>
                          <td>{free1}</td>
                          <td>{free2}</td>
                          <td>{statuses[status].label}</td>
                          <td>{pickingUser && pickingUser.displayName}</td>
                          <td>
                            <div style={{ whiteSpace: 'pre-line' }}>
                              {pendingNote}
                            </div>
                          </td>
                          <td className="text-nowrap">
                            <EditButton itemRef={ref} processValues={_ => _.status === 'initial' ? { ..._, pickingBy: null, pickedBy: null, pendingNote: null, } : _} FormModal={ModelFormModal} formProps={{ title: 'ピッキングアイテム 編集', fields: omit(fields(), 'id'), }} />
                            <DeleteButton item={pickingItem} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                ピッキングアイテムは未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
